import { useState } from "react";

function CartoMeteo() {
  const [choix, setChoix] = useState([]);
  const [nomFichier, setNomFichier] = useState("");
  const [result, setResult] = useState("");

  const options = ["cepes", "chanterelles", "morilles"];

  const handleCheckboxChange = (e) => {
    const value = e.target.value;
    setChoix(prev =>
      prev.includes(value) ? prev.filter(x => x !== value) : [...prev, value]
    );
  };

  const handleSubmit = () => {
    fetch("/api/maj_champi", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ choix_du_champi: choix, nom_fichier: nomFichier }),
    })
      .then(res => res.json())
      .then(data => setResult(data.result))
      .catch(err => setResult("Erreur : " + err.message));
  };

  return (
    <div style={{ textAlign: "center", marginTop: "2em" }}>
      <h1>Carto Météo</h1>
      <div>
        <h3>Choix du champi :</h3>
        {options.map(opt => (
          <label key={opt} style={{ margin: "0 1em" }}>
            <input
              type="checkbox"
              value={opt}
              checked={choix.includes(opt)}
              onChange={handleCheckboxChange}
            />{" "}
            {opt}
          </label>
        ))}
      </div>

      <div style={{ marginTop: "1em" }}>
        <label>
          Nom du fichier :{" "}
          <input
            type="text"
            value={nomFichier}
            onChange={(e) => setNomFichier(e.target.value)}
          />
        </label>
      </div>

      <div style={{ marginTop: "2em" }}>
        <button onClick={handleSubmit}>Lancer maj_champi</button>
      </div>

      {result && (
        <div style={{ marginTop: "2em", fontWeight: "bold" }}>
          {result}
        </div>
      )}
    </div>
  );
}

export default CartoMeteo;
